__turbopack_context__.v({
  "container": "IwfjAa_container",
  "excerpt": "IwfjAa_excerpt",
  "info": "IwfjAa_info",
  "media": "IwfjAa_media",
  "title": "IwfjAa_title",
});
